import { Exchange as IExchange } from '../../types/exchange'
import { Filters } from '../../types/general'
import { calculatePosition } from '../utils/wallet'

export async function getExchangesWithPrices(filters: Filters): Promise<IExchange[]> {
  const currency = filters.cryptocurrency?.code.toUpperCase() || ''
  const fiat = filters.fiat?.name.toUpperCase() || ''
  const url = `/api/exchanges?order=${encodeURIComponent(
    filters.order || '',
  )}&currency=${encodeURIComponent(currency)}&fiat=${encodeURIComponent(fiat)}`
  const res = await fetch(url)
  if (res.status !== 200) {
    return []
  }
  const data = (await res.json()) as IExchange[]
  return data
}

export async function getExchanges(categories: string[]): Promise<IExchange[]> {
  const url = new URL(`${process.env.NEXT_PUBLIC_STRAPI_URL}/exchanges`)
  for (const category of categories) {
    url.searchParams.append('category.code_in', category)
  }
  const res = await fetch(url.toString())
  if (res.status !== 200) {
    return []
  }

  const data = (await res.json()) as IExchange[]

  const reorderedExchanges = data.sort((firstExchange, secondExchange) => {
    const firstPosition = calculatePosition(firstExchange)
    const secondPosition = calculatePosition(secondExchange)
    return firstPosition - secondPosition
  })

  return reorderedExchanges
}
